<template>
  <div>
    <Layout/>
    <h4>Atención: Interconsulta</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoInterconsulta.idEspecialidad">
                      <option v-for="especialidad in especialidads" :value="especialidad.idEspecialidad" :key="especialidad.idEspecialidad">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoInterconsulta.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="motivo" name="motivo" v-model="datoInterconsulta.motivo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdInformeInter</th>
          <th scope="col">IdInterconsulta</th>
          <th scope="col">Cuadro</th>
          <th scope="col">Resumen</th>
          <th scope="col">PlanDiag</th>
          <th scope="col">PlanTera</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="informeinter in datosPaginados" :key="informeinter.idInformeInter">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(informeinter.idInformeInter)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(informeinter.idInformeInter)" title="Editar">edit_square</i></td>
          <td>{{informeinter.idInformeInter}}</td>
          <td>{{informeinter.idInterconsulta}}</td>
          <td>{{informeinter.cuadro}}</td>
          <td>{{informeinter.resumen}}</td>
          <td>{{informeinter.planDiag}}</td>
          <td>{{informeinter.planTera}}</td>
          <td>{{getFormattedDate(informeinter.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{informeinter.estado}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteInterconsulta(informeinter.idInformeInter)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idInformeInter" class="form-label">IdInformeInter</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInformeInter" name="idInformeInter" v-model="datoInformeInter.idInformeInter" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInformeInter.idInterconsulta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInformeInter.cuadro" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoInformeInter.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="planDiag" class="form-label">PlanDiag</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="planDiag" name="planDiag" v-model="datoInformeInter.planDiag" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="planTera" class="form-label">PlanTera</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="planTera" name="planTera" v-model="datoInformeInter.planTera" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoInformeInter.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarInformeInter" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInformeInter" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      interconsultas : [],
      datoInterconsulta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idInterconsulta: '',
      atencions : [],
      especialidads : [],
      medicos : [],
// Variables master
// Variables details
      informeinters : [],
      datoInformeInter : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      // interconsultas : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idInterconsulta = this.$route.params.p_idinterconsulta
    this.abrirEditar(this.p_idInterconsulta)
    this.getDataPagina(this.paginaActual)
    this.fetchAtencions()
    this.fetchEspecialidads()
    this.fetchMedicos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idAtencion'
        ,'idEspecialidad'
        ,'idMedico'
        ,'motivo'
        ,'cuadro'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'idEspecialidad'
        ,'idMedico'
        ,'motivo'
        ,'cuadro'
      ];
      return validarForm(this.datoInterconsulta, requiredFields, requiredFieldsText);
    },
    async guardarInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          swal("Correcto!", "Interconsulta creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          swal("Correcto!", "Interconsulta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoInterconsulta={}
      this.titulo   = 'Crear Atención: Interconsulta'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idInterconsulta){
      this.modalWindow = true
      if(idInterconsulta != null){    
           api.get('/vwinterconsultas/'+idInterconsulta).then(resp=>{
          this.datoInterconsulta = resp.data;
           });
      }
      this.titulo   = 'Editar Atención: Interconsulta'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarInterconsulta(){
      this.$router.push('/Interconsulta')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.informeinters.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwinformeinters/nombre/'+this.nombreBusqueda).then(response=>{
          this.informeinters=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.informeinters.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwinformeinters').then(response=>{
      this.informeinters=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.informeinters.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idAtencion'
        ,'idEspecialidad'
        ,'idMedico'
        ,'motivo'
        ,'cuadro'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'idEspecialidad'
        ,'idMedico'
        ,'motivo'
        ,'cuadro'
      ];
      return validarForm(this.datoInterconsulta, requiredFields, requiredFieldsText);
    },
    async guardarInformeInter(){
      if(this.validarForm() === 1){
        try {
          this.datoInformeInter.idInterconsulta = this.datoInterconsulta.idInterconsulta;
          await api.post('/informeinters', this.datoInformeInter)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "InformeInter creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInformeInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/informeinters', this.datoInformeInter)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "InformeInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoInformeInter={}
      this.titulo   = 'Crear Atención: Interconsulta'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idInformeInter){
      this.modalWindow = true
      if(idInformeInter != null){    
           api.get('/vwinformeinters/'+idInformeInter).then(resp=>{
          this.datoInformeInter = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Atención: Interconsulta'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idInformeInter){
      this.modalWindow = true
      if(idInformeInter != null){
        this.$router.push('/informeintermd/'+idInformeInter)
      }
    },
    async deleteInformeInter (idInformeInter) {
      try{
        await api.delete('/informeinters/'+idInformeInter)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchEspecialidads() {
      fetch('http://localhost:8080/api/v1/especialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
    fetchInterconsultas() {
      fetch('http://localhost:8080/api/v1/interconsultas')
        .then(response => response.json())
        .then(data => {
          this.interconsultas = data;
        })
        .catch(error => {
          console.error('Error fetching interconsultas:', error);
        });
    },
  },
}
</script>
